import i18n from 'i18next';
import { QueryClient, QueryKey } from 'react-query';

export function getMillisecondsToAnotherDay(): number {
  const now = new Date();
  const tomorrowAtStartOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

  return +tomorrowAtStartOfDay - (+now);
}

export function getErrorMessage(error: Error | { message: string | string[] }, fallbackMessage: string = i18n.t('error.defaultMessage')): string {
  if (!error)
    return fallbackMessage;

  if (error.hasOwnProperty('response'))
    return getErrorMessage((error as any)?.response?.data);

  if (!error.hasOwnProperty('message'))
    return fallbackMessage;

  if (Array.isArray(error?.message))
    return error.message[0] || fallbackMessage;

  return error?.message || fallbackMessage;
}

export async function mutateQuery<T>(queryClient: QueryClient, queryKey: QueryKey, update: (previousData: T) => T) {
  // Cancel existing requests
  await queryClient.cancelQueries(queryKey);

  // Snapshot the previous value
  const previousData = queryClient.getQueryData<T>(queryKey);

  // Optimistically update to the new value
  if (previousData) {
    queryClient.setQueryData<T>(queryKey, update(previousData));
  }
}

export type OptimisticUpdateEvents = { onMutate: () => Promise<void>, onSettled: () => Promise<void> }

export function createOptimisticUpdate<T>(queryClient: QueryClient, queryKey: QueryKey, update: (previousData: T) => T): OptimisticUpdateEvents {
  return {
    onMutate: () => mutateQuery(queryClient, queryKey, update),
    onSettled: () => queryClient.refetchQueries(queryKey),
  };
}
